const QLD_NT_STATES = new Set(['QLD', 'NT']);

export const isQldOrNtState = (state: string | undefined): boolean =>
  !!state && QLD_NT_STATES.has(state.toUpperCase());
